export const COLORS : {[key:string]: { value:string, hex:string }} = {
  black                   : { value: 'black', hex: '#000000' },
  white                   : { value: 'white', hex: '#ffffff' },
  deserttan               : { value: 'deserttan', hex: '#aa8e5c' },
  gray                    : { value: 'gray', hex: '#757575' },
  navy                    : { value: 'navy', hex: '#123b60' },
  blue                    : { value: 'blue', hex: '#1938f4' },
  lightblue               : { value: 'lightblue', hex: '#5cd6f2' },
  purple                  : { value: 'purple', hex: '#9427f4' },
  green                   : { value: 'green', hex: '#666b51' },
  lightgreen              : { value: 'lightgreen', hex: '#abd821' },
  pink                    : { value: 'pink', hex: '#f91aff' },
  maroon                  : { value: 'maroon', hex: '#7c1c1c' },
  red                     : { value: 'red', hex: '#f20000' },
  orange                  : { value: 'orange', hex: '#ea7a00' },
  tekgraycamo             : { value: 'tekgraycamo', hex: 'tekgray' },
  tigerstripewoodlandcamo : { value: 'tigerstripewoodlandcamo', hex: 'woodland' },
}

export const KNEESLEEVE_SWATCH_COLORS: { [key:string]: string } =  {
  black      : '#000000',
  white      : '#ffffff',
  deserttan  : '#aa8e5c',
  gray       : '#757575',
  navy       : '#123b60',
  blue       : '#1938f4',
  lightblue  : '#5cd6f2',
  darkgreen  : '#4A4633',
  purple     : '#9427f4',
  green      : '#666b51',
  lightgreen : '#abd821',
  pink       : '#f91aff',
  maroon     : '#7c1c1c',
  red        : '#f20000',
  orange     : '#ea7a00',
}

export const KNEE_SLEEVE_COLOR_OPTION: {imgAttr: string, label: string}[] = [
  {
    imgAttr : 'black',
    label   : 'Black',
  },
  {
    imgAttr : 'white',
    label   : 'White',
  },
  {
    imgAttr : 'deserttan',
    label   : 'Desert Tan',
  },
  {
    imgAttr : 'gray',
    label   : 'Gray',
  },
  {
    imgAttr : 'navy',
    label   : 'Navy',
  },
  {
    imgAttr : 'blue',
    label   : 'Blue',
  },
  {
    imgAttr : 'lightblue',
    label   : 'Light Blue',
  },
  {
    imgAttr : 'purple',
    label   : 'Purple',
  },
  {
    imgAttr : 'darkgreen',
    label   : 'Dark Green',
  },
  {
    imgAttr : 'green',
    label   : 'green',
  },
  {
    imgAttr : 'lightgreen',
    label   : 'Light Green',
  },
  {
    imgAttr : 'pink',
    label   : 'Pink',
  },
  {
    imgAttr : 'maroon',
    label   : 'Maroon',
  },
  {
    imgAttr : 'red',
    label   : 'Red',
  },
  {
    imgAttr : 'orange',
    label   : 'Orange',
  },
  {
    imgAttr : 'tigerstripewoodlandcamo',
    label   : 'Camo',
  },
  {
    imgAttr : 'tekgraycamo',
    label   : 'TekGray',
  },
  {
    imgAttr : 'gold',
    label   : 'Gold',
  },

]

export const ROGUE_SWATCH_OPTS: Object[] = [
  {
    label : 'Barbell Club',
    value : 'club',
  },
  {
    label : 'Zeus',
    value : 'zeus',
  },
  {
    label : 'Rogue International',
    value : 'international',
  },
  {
    label : 'American Flag',
    value : 'flag',
  },
]

export const ROGUE_IMAGES: {[key:string]: string} = {
  international_white : 'Rogue_International_Logo_sst59x.svg',
  international_gold  : 'RogueInternational_Gold_jjbohe.svg',
  international_red   : 'RogueInternational_Red_c8gtmc.svg',
  international_black : 'RogueInternational_Black_eyptsm.svg',
  flag                : 'Flag_logo__pxfte6.svg',
  zeus                : 'Zeus_logo__y65i9u.svg',
  club                : 'Barbell_Club_logo__twavxa.svg',
}
